import axios from "axios";
import React, { useEffect, useState } from "react";
import { toast } from "react-toastify";
import styled from "styled-components";
import { COLORS } from "../../../COLORS";
import Annonce from "../../Annonces/Annonce/Annonce";
import { useNavigate } from "react-router-dom";
type TypeAnnonce = {
  categorie: string;
  createdAt: string;
  description: string;
  images?: [string];
  numero: string;
  price: string;
  pseudo: string;
  status: number;
  titre: string;
  type: string;
  updatedAt: string;
  ville: string;
  __v: number;
  _id: string;
};
const RecentsAnnonces = () => {
  const [annonces, setAnnonces] = useState<TypeAnnonce[]>([]);
  const [loade, setLoade] = useState(true);
  const [oneAnnonce, setOneAnnonce] = useState("");
  const nav = useNavigate();
  const getAllAnnonces = async () => {
    if (!loade) {
      setLoade(true);
    }
    try {
      const res = await axios({
        method: "get",
        url: `${process.env.REACT_APP_API}annonces/some/three`,
        withCredentials: true,
      });
      if (res.data) {
        setLoade(false);
        setAnnonces(res.data);
      }
    } catch (error) {
      setLoade(false);
      console.log(error);
      return toast.error(
        "Une erreur est survenue lors du chargement des données"
      );
    }
  };
  useEffect(() => {
    getAllAnnonces();
  }, []);
  return (
    <StyledRecentsAnnonces>
      <h3>Annonces récentes : </h3>
      <div className="list-annonce-recente" onClick={() => nav(`/annonces`)}>
        {annonces &&
          annonces.length > 0 &&
          annonces.map((annonce) => (
            <Annonce
              key={annonce._id}
              id={annonce._id}
              categorie={annonce.categorie}
              description={annonce.description}
              image={annonce.images}
              numero={annonce.numero}
              price={annonce.price}
              pseudo={annonce.pseudo}
              titre={annonce.titre}
              type={annonce.type}
              ville={annonce.ville}
              setOneAnnonce={setOneAnnonce}
            />
          ))}
      </div>
    </StyledRecentsAnnonces>
  );
};

export default RecentsAnnonces;

const StyledRecentsAnnonces = styled.div`
  display: flex;
  flex-direction: column;
  margin: 20px auto;
  padding: 10px;
  h3 {
    font-size: 1.5em;
    color: ${COLORS.white};
  }
  .list-annonce-recente {
    width: 80%;
    margin: 0px auto;
    display: flex;
    flex-wrap: wrap;
    justify-content: center;
  }
  @media screen and (max-width: 450px) {
    padding: 3px;
    margin: 5px auto;
    .list-annonce-recente {
      width: 100%;
    }
  }
`;
